/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNavigationMenuPrimaryItemFragment, NavigationMenuPrimaryItemFragment, FullNavigationMenuPrimaryItemFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu-primary-item';

/**
 * Get a single NavigationMenuPrimaryItem by ID (base - scalars only)
 */
export const getBaseNavigationMenuPrimaryItemById = gql`
  ${BaseNavigationMenuPrimaryItemFragment}

  query GetBaseNavigationMenuPrimaryItemById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenuPrimaryItem(id: $id, locale: $locale, preview: $preview) {
      ...BaseNavigationMenuPrimaryItemFragment
    }
  }
`;

/**
 * Get a single NavigationMenuPrimaryItem by ID (standard - 1 level deep)
 */
export const getNavigationMenuPrimaryItemById = gql`
  ${NavigationMenuPrimaryItemFragment}

  query GetNavigationMenuPrimaryItemById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenuPrimaryItem(id: $id, locale: $locale, preview: $preview) {
      ...NavigationMenuPrimaryItemFragment
    }
  }
`;

/**
 * Get a single NavigationMenuPrimaryItem by ID (full - 2 levels deep)
 */
export const getFullNavigationMenuPrimaryItemById = gql`
  ${FullNavigationMenuPrimaryItemFragment}

  query GetFullNavigationMenuPrimaryItemById($id: String!, $locale: String!, $preview: Boolean) {
    navigationMenuPrimaryItem(id: $id, locale: $locale, preview: $preview) {
      ...FullNavigationMenuPrimaryItemFragment
    }
  }
`;

/**
 * Get all NavigationMenuPrimaryItem entries with pagination (base - scalars only)
 */
export const getBaseNavigationMenuPrimaryItems = gql`
  ${BaseNavigationMenuPrimaryItemFragment}

  query GetBaseNavigationMenuPrimaryItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuPrimaryItemOrder]
    $where: NavigationMenuPrimaryItemFilter
    $preview: Boolean
  ) {
    navigationMenuPrimaryItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseNavigationMenuPrimaryItemFragment
      }
    }
  }
`;

/**
 * Get all NavigationMenuPrimaryItem entries with pagination (standard - 1 level deep)
 */
export const getNavigationMenuPrimaryItems = gql`
  ${NavigationMenuPrimaryItemFragment}

  query GetNavigationMenuPrimaryItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuPrimaryItemOrder]
    $where: NavigationMenuPrimaryItemFilter
    $preview: Boolean
  ) {
    navigationMenuPrimaryItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...NavigationMenuPrimaryItemFragment
      }
    }
  }
`;

/**
 * Get all NavigationMenuPrimaryItem entries with pagination (full - 2 levels deep)
 */
export const getFullNavigationMenuPrimaryItems = gql`
  ${FullNavigationMenuPrimaryItemFragment}

  query GetFullNavigationMenuPrimaryItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [NavigationMenuPrimaryItemOrder]
    $where: NavigationMenuPrimaryItemFilter
    $preview: Boolean
  ) {
    navigationMenuPrimaryItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullNavigationMenuPrimaryItemFragment
      }
    }
  }
`;
